export default __webpack_public_path__ + "static/media/redspread.6b7ea924.svg";